import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdfjs-worker.min.mjs`;

const ENCRYPTED_PDF_MESSAGE =
  "El PDF está protegido con contraseña. Retire la contraseña e inténtelo de nuevo. Puede usar una herramienta como iLovePDF para desbloquear el PDF.";

const isPdfFile = (file) => {
  if (!file) return false;
  if (file.type === "application/pdf") return true;
  return typeof file.name === "string" && file.name.toLowerCase().endsWith(".pdf");
};

export const isPdfEncrypted = async (file) => {
  if (!isPdfFile(file)) return false;

  let data;
  try {
    data = new Uint8Array(await file.arrayBuffer());
  } catch {
    return false;
  }

  const loadingTask = pdfjsLib.getDocument({
    data,
    password: "",
    isEvalSupported: false,
    useSystemFonts: false,
  });

  try {
    const doc = await loadingTask.promise;
    await doc.destroy();
    return false;
  } catch (error) {
    return error?.name === "PasswordException";
  }
};

export const assertPdfNotEncrypted = async (file) => {
  const encrypted = await isPdfEncrypted(file);
  return encrypted ? ENCRYPTED_PDF_MESSAGE : null;
};
